module.exports = __webpack_public_path__ + "static/home-hero-mobile-10th-82512b746a016db62d7925f50ca92e6d.png";